const Loader = ({
  size = "medium",
  text = "",
}) => {
  const sizeClasses = {
    small: "w-4 h-4 border-2",
    medium: "w-8 h-8 border-4",
    large: "w-12 h-12 border-4",
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className={`
          ${sizeClasses[size] || sizeClasses.medium}
          border-gray-200
          border-t-blue-600
          rounded-full
          animate-spin
        `}
      />

      {text && (
        <p className="text-sm text-gray-500">
          {text}
        </p>
      )}
    </div>
  );
};

export default Loader;